/**
 * The grouped detail cards of a workspace page (a task, a split job): the same
 * soft frame as the progress card, and the small caps label over each value.
 */
export const DETAIL_CARD_SX = {
  px: 1.5,
  py: 1.25,
  borderRadius: 1.5,
  border: 1,
  borderColor: "divider",
  bgcolor: (theme: { palette: { mode: string } }) =>
    theme.palette.mode === "dark" ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.018)",
} as const;

export const DETAIL_LABEL_SX = {
  display: "block",
  lineHeight: 1.2,
  letterSpacing: 0.06,
  fontWeight: 700,
  fontSize: 10,
  color: "text.secondary",
} as const;
